import {
	Context,
	createContext,
	PropsWithChildren,
	useCallback,
	useContext,
	useEffect,
	useState,
} from 'react'
import appConfigurationService from '../services/appConfigurationService'
import React from 'react'
import AuthContext from './auth'
interface IAppConfigContext {
	toggle: string[]
	ready: boolean
}

const AppConfigContext: Context<IAppConfigContext> =
	createContext<IAppConfigContext>({
		toggle: [],
		ready: false,
	})

export function UseAzureAppConfigProvider({
	children,
}: PropsWithChildren<any>) {
	const { isAuthenticated } = useContext(AuthContext)
	const [toggle, setToggle] = useState<string[]>([])
	const [ready, setReadyState] = useState(false)

	const getConfig = useCallback(async () => {
		await appConfigurationService
			.getConfigurationSetting('toggling*')
			.then((data) => {
				setToggle(data)
				setReadyState(true)
			})
	}, [])

	useEffect(() => {
		//useEffect cleanup function for auth provider
		if (isAuthenticated === true) {
			getConfig()
		}
		return () => {}
	}, [getConfig, isAuthenticated])

	return (
		<AppConfigContext.Provider value={{ toggle, ready }}>
			{children}
		</AppConfigContext.Provider>
	)
}

export default AppConfigContext
